import { ReactNode } from 'react';
import { Box, BoxProps } from '@nimbus-ds/components';

export interface InterfaceStackItem extends Omit<BoxProps, 'children'> {
  /** React node of type children */
  children?: ReactNode;
  /** Define whether the item should stretch beyond it's limit */
  fill?: boolean;
}

/**
 * @param children React node of type children
 * @param fill Define whether the item should stretch beyond it's limit
 */
function Item({
  children,
  fill = false,
  ...props
}: InterfaceStackItem): JSX.Element {
  const flex = fill ? '1 1 auto' : '0 1 auto';
  return (
    <Box flex={flex} {...props}>
      {children}
    </Box>
  );
}

Item.displayName = 'Stack.Item';

export default Item;
